import getBasePath from '../../../../../common/functions/api-resource';

const basePath = getBasePath('relatorio', 'historico');

const relatorioActions = {
  salvaHistoricoProvisao: { method: 'POST', url: `${basePath}/salvar-historico-provisao` },
};

export default resource => resource(`${basePath}`, {}, relatorioActions);



// WEBPACK FOOTER //
// ./src/custom/abbrasil/common/resources/relatorio/historico-relatorio.js